@if (authService.isLoggingIn()) {
    <crczp-sign-in-status [version]="version" />
} @else if (!hideSidebar()) {
    <sentinel-layout1 (login)="onLogin()"
                      (logout)="onLogout()"
                      [agendaContainers]="agendaContainers$ | async"
                      [displayNotificationsIcon]="true"
                      [isLoading]="loadingService.isLoading$ | async"
                      [notificationsRoute]="notificationRoute"
                      [user]="authService.activeUser$ | async"
                      [version]="version"
                      logoSrc="./assets/logo/logo.svg">
        <div role="toolbar">
            @if (authService.activeUser$ | async) {
                <span class="username">{{ (authService.activeUser$ | async).nameWithAcademicTitles }}</span>
            }
        </div>
        @if (title(); as title) {
            <h1>{{ title }}</h1>
        }
        <router-outlet />
    </sentinel-layout1>
} @else {
    <sentinel-toolbar
        (login)="onLogin()"
        (logout)="onLogout()"
        [displayNotifications]="true"
        [notificationsRoute]="notificationRoute"
        [user]="authService.activeUser$ | async">
        <div role="toolbar">
            @if (authService.activeUser$ | async) {
                <span class="username">{{ (authService.activeUser$ | async).nameWithAcademicTitles }}</span>
            }
        </div>
    </sentinel-toolbar>

    <router-outlet />
}
